import { Moment } from 'moment'
// 检查表单
const columnsExamine = [
  {
    title: '检查单ID',
    dataIndex: 'checklistId',
    key: 'checklistId',
    fixed: 'left',
    width: 120,
    slots: { customRender: 'checklistId' }
  },
  {
    title: '临观活动名称',
    dataIndex: 'clinicalName',
    key: 'clinicalName',
    width: 135
  },
  {
    title: '随访计划ID',
    dataIndex: 'adPlanId',
    key: 'adPlanId',
    slots: { customRender: 'adPlanId' },
    width: 120
  },

  {
    title: '患者ID',
    dataIndex: 'patientId',
    key: 'patientId',
    width: 100
  },
  {
    title: '患者姓名',
    dataIndex: 'patientName',
    key: 'patientName',
    width: 100
  },
  {
    title: '就诊人姓名',
    width: 120,
    customRender: ({ record }) => {
      return record.patientProfileCommonVO?.patientProfileName || '--'
    }
  },
  {
    title: '表单状态',
    dataIndex: 'formStatusString',
    key: 'formStatusString',
    width: 100
  },
  {
    title: '上传时间',
    dataIndex: 'uploadTime',
    key: 'uploadTime',
    width: 135
  },
  {
    title: '编辑时间',
    dataIndex: 'editTime',
    key: 'editTime',
    width: 135
  },
  {
    title: '编辑人',
    dataIndex: 'editName',
    key: 'editName',
    width: 120,
    slots: { customRender: 'editName' }
  },
  {
    title: '操作',
    key: 'handle',
    dataIndex: 'handle',
    fixed: 'right',
    width: 70,
    slots: { customRender: 'handle' }
  }
]
const paginationConfig = {
  current: 1,
  pageSize: 20,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
}
// 	问题类型: 1整数，2小数，3日期，4单行文本，5 多行文本 6 单选框
const formItemType = [
  {
    fType: 1,
    type: 'number',
    default: null
  },
  {
    fType: 2,
    type: 'number',
    default: null
  },
  {
    fType: 3,
    type: 'date',
    default: Moment | undefined
  },
  {
    fType: 4,
    type: 'string',
    default: ''
  },
  {
    fType: 5,
    type: 'string',
    default: ''
  },
  {
    fType: 6,
    type: 'string',
    default: ''
  }
]

const formStatus = [
  {
    value: 2,
    text: '已录入'
  },
  {
    value: 1,
    text: '未录入'
  }
]
const prescriptionType = [
  {
    value: 0,
    text: '线上处方'
  },
  {
    value: 1,
    text: '线下处方'
  }
]
export { columnsExamine, paginationConfig, formItemType, formStatus, prescriptionType }
